interface SectionHeadingProps {
  kicker?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  id?: string;
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "left",
  id,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      {kicker && (
        <div
          className={`inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-primary-600 ${
            isCenter ? "justify-center" : ""
          }`}
        >
          <span className="w-6 h-px bg-primary-500" />
          {kicker}
        </div>
      )}
      <h2
        id={id}
        className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug"
      >
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
      )}
    </div>
  );
}